import PropTypes from 'prop-types'

// Mui
import { alpha, styled } from '@mui/material/styles'

// Simple Scroll
import SimpleBarReact from 'simplebar-react'
import 'simplebar-react/dist/simplebar.min.css'

// -------------------------------------------------------------
const RootStyle = styled('div')(() => ({
  flexGrow: 1,
  height: '100%',
  overflow: 'hidden',
}))

const SimpleBarStyle = styled(SimpleBarReact)(({ theme }) => ({
  maxHeight: '100%',
  '& .simplebar-scrollbar': {
    '&:before': {
      backgroundColor: alpha(theme.palette.grey[600], 0.48),
    },
    '&.simplebar-visible:before': {
      opacity: 1,
    },
  },
  '& .simplebar-track.simplebar-vertical': {
    width: 10,
  },
  '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
    height: 6,
  },
  '& .simplebar-mask': {
    zIndex: 'inherit',
  },
}))
//--------------------------------------------------------------------

const ScrollBar = ({ children }) => {
  return (
    <RootStyle>
      <SimpleBarStyle timeout={500} clickOnTrack={false}>
        {children}
      </SimpleBarStyle>
    </RootStyle>
  )
}

ScrollBar.prototype = {
  children: PropTypes.node,
}

export default ScrollBar
